import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
export const useResolvedColumnCallToAction = t0 => {
  const $ = _c(10);
  const {
    columnCallToAction,
    columnsWithDefaults,
    rows,
    numberOfFrozenColumns
  } = t0;
  let t1;
  bb0: {
    if (!columnCallToAction) {
      t1 = null;
      break bb0;
    }
    let t2;
    if ($[0] !== columnCallToAction.columnName || $[1] !== columnCallToAction.columnNamespace) {
      t2 = column => {
        if (column.columnName !== columnCallToAction.columnName) {
          return false;
        }
        if (columnCallToAction.columnNamespace === undefined) {
          return true;
        }
        return column.columnNamespace === columnCallToAction.columnNamespace;
      };
      $[0] = columnCallToAction.columnName;
      $[1] = columnCallToAction.columnNamespace;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    const columnIndex = columnsWithDefaults.findIndex(t2);
    const rowIndex = columnCallToAction.rowIndex;
    const hasResolvedColumnAndRows = columnIndex !== -1 && rows.length > 0;
    const isRowIndexValid = Number.isInteger(rowIndex) && rowIndex >= 0 && rowIndex < rows.length;
    if (!hasResolvedColumnAndRows || !isRowIndexValid) {
      t1 = null;
      break bb0;
    }
    const t3 = columnIndex < numberOfFrozenColumns;
    let t4;
    if ($[3] !== columnCallToAction.content || $[4] !== columnCallToAction.popoverInlineSize || $[5] !== columnCallToAction.type || $[6] !== columnIndex || $[7] !== rowIndex || $[8] !== t3) {
      t4 = {
        columnIndex,
        rowIndex,
        type: columnCallToAction.type,
        content: columnCallToAction.content,
        isColumnFrozen: t3,
        popoverInlineSize: columnCallToAction.popoverInlineSize
      };
      $[3] = columnCallToAction.content;
      $[4] = columnCallToAction.popoverInlineSize;
      $[5] = columnCallToAction.type;
      $[6] = columnIndex;
      $[7] = rowIndex;
      $[8] = t3;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t1 = t4;
  }
  return t1;
};